import $ from 'jquery';

const accordionByLink = () => {

    const doStuff = (target) => {
        if (target !== undefined) {
            $(target).collapse('show');

             $([document.documentElement, document.body]).animate({
                 scrollTop: $(target).offset().top-200
             });

            removeHash();
        }

    }
    const removeHash = () => {
        history.pushState("", document.title, window.location.pathname
            + window.location.search);
    }
    if (document.querySelector('.ume-accordion-wrapper')) {
        if (window.location.hash) {
            const target = window.location.hash;
            doStuff(target);


        }
        window.addEventListener('hashchange', () => {
            const target = window.location.hash;
            doStuff(target);
        })
    }

}
export default accordionByLink;